<template lang="pug">
  shListData(title="Tiers History" resolver="tiersHistory" keyData="_id" component="shTier" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'TiersHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/tier/TiersHistory.vue